<script lang="ts">
	import { Button, ButtonType } from '@repo/commons/components'
	import { ChatInput } from './index.ts'

	interface Props {
		showAttachButton?: boolean
		onSend: (message: string) => void
	}

	let { showAttachButton = true, onSend }: Props = $props()
	let message: string = $state('')

	function handleSend() {
		if (!message.trim()) return
		onSend?.(message.trim())
		message = ''
	}

	function handleKeydown(e: KeyboardEvent) {
		if (e.key === 'Enter' && !e.shiftKey) {
			e.preventDefault()
			handleSend()
		}
	}

	const messageExists = $derived.by(() => message.trim().length > 0)
</script>

<div class="chatInputBox">
	{#if showAttachButton}
		<Button buttonText="" buttonType={ButtonType.CUSTOM} iconProps={{ name: 'attachFile' }} />
	{/if}
	<ChatInput bind:input={message} {handleKeydown} />
	<Button
		buttonText=""
		buttonType={ButtonType.CUSTOM}
		disabled={messageExists ? false : true}
		onclick={handleSend}
		iconProps={{ name: 'sendMessage' }}
	/>
</div>

<style lang="postcss">
	.chatInputBox {
		@apply flex gap-2 p-4 border border-[#002c4d80] border-solid rounded-lg w-full;
	}
</style>
